export default __webpack_public_path__ + "static/grouped-column-78b385769602b0301244c318905171e7.png";